import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { DialogAction } from '../dialogs-configuration';
import { DialogConfigBase } from '../dialog-config-base';
import { DialogConfigInterface } from '../dialog-config.interface';
import { DialogComponentInterface } from '../dialog-component.interface';

@Component({
  selector: 'app-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss']
})
export class InformationDialogComponent implements OnInit, DialogComponentInterface {

  static getConfigBuilder(): any {
    return new InformationDialogConfig();
  }

  get buttonVisible(): boolean {
    return isNotNullOrUndefined(this.data.actionText);
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: InformationDialogData) {
  }

  ngOnInit() {
  }

}

export class InformationDialogConfig extends DialogConfigBase implements DialogConfigInterface {

  private config: MatDialogConfig = {
  };

  constructor() {
    super();
  }

  buildConfiguration(data: InformationDialogData): MatDialogConfig {
    this.config.disableClose = isNotNullOrUndefined(data.disableClose) ? data.disableClose : true;
    this.config.panelClass = data.panelClass ? data.panelClass : 'app-dialog';
    return this.buildConfig(data, this.config);
  }
}

export interface InformationDialogData {
  header: string;
  mainText: string;
  imageSrc?: string;
  additionalText?: string;
  footer?: string;
  actionText: string;
  actionKey?: DialogAction;
  disableClose: boolean;
  imageAboveHeader?: boolean;
  dialogClass?: string;
  panelClass?: string;
  canCloseOnNavigation?: boolean; // if false, dialog won't be closed by service when user navigates using browser (e.g. back)
}
